import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { acGetAllPlans, acDeletePlan } from '../../../store/actions'
import { ERRORS } from '../../../store/constants'
import { ConfirmModal, Snackbar } from '../../default'

/**
 * @description DeletePlanModal function displays a modal for deleting a plan.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines whether the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @param {object} selectedPlan - The selected plan to be deleted.
 * @returns {JSX.Element} - The DeletePlanModal component.
 */
const DeletePlanModal = ({ open, onClose, selectedPlan }) => {

    const dispatch = useDispatch()

    const [snackbarData, setSnackbarData] = useState({ open: false, severity: 'success', message: '' })

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setSnackbarData({ ...snackbarData, open: false })
    }

    const onConfirm = () => {
        dispatch(acDeletePlan(selectedPlan.plan_id))
            .then(() => {
                onClose()
                setSnackbarData({ open: true, severity: 'success', message: `Plano #${selectedPlan.plan_id} excluído com sucesso!` })
                dispatch(acGetAllPlans())
                    .catch(error => console.error(error))
            })
            .catch(err => {
                console.error(err)
                onClose()
                setSnackbarData({ open: true, severity: 'error', message: `Não foi possível excluir o plano #${selectedPlan.plan_id}. ${ERRORS[err.description]}` })
            })
    }

    return (
        <>
            <ConfirmModal
                open={open} onClose={onClose} onConfirm={onConfirm}
                title='Excluir Plano'
                id={selectedPlan?.plan_id}
                description={`Você tem certeza que deseja excluir o "${selectedPlan?.name}" ?`}
            />
            <Snackbar
                open={snackbarData.open}
                onClose={handleSnackbarClose}
                severity={snackbarData.severity}
                message={snackbarData.message}
                vertical='bottom'
                horizontal='right'
                variant='filled'
                sx={{ mt: 1 }}
            />
        </>
    )

}

DeletePlanModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedPlan: PropTypes.object
}

export default DeletePlanModal